/* eslint-disable no-debugger */
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { IDimensionForSelectedVariant } from '@msdyn365-commerce-modules/retail-actions';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

var zip = JSZip();

export default async (
    product: SimpleProduct | undefined,
    productDimensions: IDimensionForSelectedVariant[] | undefined,
    baseImageUrl: string | undefined
) => {
    const urls: string[] = [];

    if (product) {
        const fullUrl = `${baseImageUrl}Products/${product.ItemId}_000_`;
        const imageUrl = `${product.ItemId}_000_`;
        const numberOfImages: number[] = [1, 2, 3, 4, 5];

        numberOfImages.map(imageNumber => urls.push(`${imageUrl}00${imageNumber}.png`, `${fullUrl}00${imageNumber}.png`));
    }

    if (product && productDimensions && productDimensions[0] && productDimensions[0].DimensionValues) {
        productDimensions[0].DimensionValues.map(dimension => {
            const fullUrl = `${baseImageUrl}Products/${product.ItemId} ^ ${dimension.DimensionId}_000_`;
            const imageUrl = `${product.ItemId} ^ ${dimension.DimensionId}_000_`;
            const numberOfImages: number[] = [1, 2, 3, 4, 5];

            numberOfImages.map(imageNumber => urls.push(`${imageUrl}00${imageNumber}.png`, `${fullUrl}00${imageNumber}.png`));
        });
    }

    const responses = await Promise.all(
        urls.map(url =>
            fetch(url).then(r => {
                if (r.status === 200) {
                    return { blob: r.blob(), url: url };
                } else {
                    return null;
                }
            })
        )
    );
    addToArchive(
        responses.filter(response => response !== null),
        baseImageUrl
    );
    download(product?.ItemId);
};

const addToArchive = (reponses: any[], baseImageUrl: string | undefined) => {
    reponses.map(response => {
        const fileName: string = response.url.replace(`${baseImageUrl}Products/`, '');
        zip.file(fileName, response.blob, { binary: true });
    });
};

const download = (itemId?: string) => {
    void zip.generateAsync({ type: 'blob' }).then(function(blob) {
        saveAs(blob, `LOBAS_${itemId}.zip`);
    });
};
